<template>
    <div>
         <div class="suggestions" id="sticky-sidebar">
              <h4 class="grey">Shops Followed</h4>
              <div class="follow-user">
                <img src="http://placehold.it/300x300" alt="" class="profile-photo-sm pull-left" />
                <div>
                  <h5><a href="timeline#">Simi Shapers</a></h5>
                  <a href="#" class="text-green">Follow Shop</a>
                </div>
              </div>
              <div class="follow-user">
                <img src="http://placehold.it/300x300" alt="" class="profile-photo-sm pull-left" />
                <div>
                  <h5><a href="timeline#">Chris Foodstore</a></h5>
                  <a href="#" class="text-green">Follow Shop</a>
                </div>
              </div>
              <div class="follow-user">
                <img src="http://placehold.it/300x300" alt="" class="profile-photo-sm pull-left" />
                <div>
                  <h5><a href="timeline#">Olafumi Jewellries</a></h5>
                  <a href="#" class="text-green">Follow Shop</a>
                </div>
              </div>
              <div class="follow-user">
                <img src="http://placehold.it/300x300" alt="" class="profile-photo-sm pull-left" />
                <div>
                  <h5><a href="timeline#">Trish Hairs</a></h5>
                  <a href="#" class="text-green">Follow Shop</a>
                </div>
              </div>
              <div class="follow-user">
                <img src="http://placehold.it/300x300" alt="" class="profile-photo-sm pull-left" />
                <div>
                  <h5><a href="timeline#">Nina Organics</a></h5>
                  <a href="#" class="text-green">Follow Shop</a>
                </div>
              </div>
            </div>
   
   <div v-if="loggedIn" class="hidden-md hidden-lg">
     <hr/>
     <h3>Your Profile</h3>
              <div class="profile-card">
                <img src="http://placehold.it/300x300" alt="user" class="profile-photo" />
                <h5><a href="timeline" class="text-white">{{user.user_name}}</a></h5>
                <a href="#" class="text-white"><i class="fa fa-shopping-cart"></i> 62 shops</a><br>
                <a href="#" class="text-white"><i class="ion ion-android-person-add"></i> 1,500 friends</a>
                
              </div><!--profile card ends-->
              <ul class="nav-news-feed">
                <li><i class="icon ion-ios-paper"></i><div><a href="#">Tradefair Newsfeed</a></div></li>
                <li><i class="icon fa fa-shopping-cart"></i><div><a href="#">Shops Following</a></div></li>
                <li><i class="icon ion-ios-people-outline"></i><div><a href="#">Friends</a></div></li>
                <li><i class="icon ion-chatboxes"></i><div><a href="#">Discussions / Messages</a></div></li>
                <li><i class="icon ion-images"></i><div><a href="#">Orders</a></div></li>
                <li><i class="icon fa fa-bell"></i><div><a href="#">No6ifications</a></div></li>
              </ul><!--news-feed links ends-->
            </div>
    </div>
</template>

<script>
import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'RightSidebar',
    data () {
      return {
        user: {}, 
        loggedIn:false
      }
  },

methods: {
    checkLoggedIn(){
        if(localStorage.getItem("sp_token") != null){
            this.loggedIn = true;
            this.user.user_name = localStorage.getItem("sp_user");
        }
    },
  },
  created: function() {
    this.checkLoggedIn();
  }
}
</script>


// WEBPACK FOOTER //
// rightsidebar.vue?05e07ac0